import React from 'react'
import Grid from '@mui/material/Grid'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import ItemContextMenu from '../../util/ItemContextMenu'
import { VisaoPorAuditorProcessosGrupoComum } from './VisaoPorAuditorProcessosGrupoComum'

export class VisaoPorAuditorProcessosQueInstrui extends VisaoPorAuditorProcessosGrupoComum {
  constructor(props) {
    super(props)
    this.state = {
      expandedHistory: false
    }
  }

  render() {
    const { indicadorComponentContextMenuAnchorEl } = this.state
    const {
      itens: {
        visao: { processosQueInstruiPorAuditor }
      }
    } = this.props
    return (
      <Grid item xs={12}>
        {this.renderProcessosQueAtueiInstruiCard(processosQueInstruiPorAuditor)}
        <ItemContextMenu
          itemContextMenuAnchorEl={indicadorComponentContextMenuAnchorEl}
          handleItemContextMenuClose={this.handleIndicadorComponentItemContextMenuClose.bind(this)}
          handleItemContextMenuItemClick={this.handleIndicadorComponentItemContextMenuItemClick.bind(
            this
          )}
        />
      </Grid>
    )
  }
}

const mapStateToProps = ({ filtros, itens }) => ({ filtros, itens })

const reduxEnhanced = connect(mapStateToProps)(VisaoPorAuditorProcessosQueInstrui)

export default withRouter(reduxEnhanced)
